import Button from "../Shared/Button";
import ModalVideo from 'react-modal-video';
import { useState } from 'react';
import consulting from "../../assets/Consultation.jpg"
import { Link } from "react-router-dom";



const About2 = () => {

    const [isOpen, setOpen] = useState(false);
    <ModalVideo
        channel="youtube"
        youtube={{ mute: 0, autoplay: 0 }}
        isOpen={isOpen}
        videoId="L61p2uyiMSo"
        onClose={() => setOpen(false)}
    />


    return (
        <>

            <div>
                <ModalVideo
                    channel="youtube"
                    youtube={{ mute: 0, autoplay: 0 }}
                    isOpen={isOpen}
                    videoId=""
                    onClose={() => setOpen(false)}
                />

                <div className="sm:h-[600px] h-[500px] w-full relative">

                    <div className="bg-gradientBg2 opacity-70 absolute inset-0 z-10 size-full" />
                    <div className="absolute inset-0 h-full w-full">
                        <img
                            src={consulting}
                            className="h-full w-full object-cover object-top"
                            alt=""
                        />
                    </div>
                    <div className="flex h-full lg:justify-between justify-center lg:gap-0 sm:gap-10 gap-6 items-center lg:flex-row flex-col-reverse relative z-50 container">
                        <div className="sm:space-y-5 space-y-2.5 text-white flex flex-col lg:text-start text-center lg:justify-end items-center lg:items-start lg:h-full lg:pb-32">
                            <h1 className="font-semibold sm:text-base text-sm">About NileWise!
                            </h1>
                            <h2 className="lg:text-4xl md:text-3xl sm:text-2xl text-xl max-w-[700px] font-semibold">we provides specialized courses, professional training, and tailored consultations to empower individuals and organizations to enhance their skills and achieve lasting success.</h2>
                            <Link to={"/about-us"}><Button className="w-[147px] !text-white sm:!h-[55px] !h-12 sm:!text-base !text-sm !border-white hover:before:!bg-[#f9b001] hover:!border-[#f9b001]" variant="transparent">Read More</Button></Link>
                        </div>
                        <button onClick={() => setOpen(true)} className="sm:min-h-20 sm:min-w-20 min-w-16 min-h-16 bg-[#f9b001] rounded-full flex justify-center items-center pulse-animation lg:mt-20">
                            <svg width="3em" height="3em" viewBox="0 0 16 16" className="bi bi-play-fill text-white" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.596 8.697l-6.363 3.692c-.54.313-1.233-.066-1.233-.697V4.308c0-.63.692-1.01 1.233-.696l6.363 3.692a.802.802 0 0 1 0 1.393z" />
                            </svg>
                        </button>

                    </div>
                </div>

            </div>
        </>
    )
}

export default About2